import React from 'react';

export default class ComparisonButtons extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div>
        <button 
          className="button--symbol" 
          type="button" 
          onClick={() => this.props.updateEqualitySymbol('<')}>
          &#60;
        </button>

        <button 
          className="button--symbol" 
          type="button" 
          onClick={() => this.props.updateEqualitySymbol('=')}>
          =
        </button>
        
        <button 
          className="button--symbol" 
          type="button" 
          onClick={() => this.props.updateEqualitySymbol('>')}>
          &#62;
        </button>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./client/app/scripts/components/inequality/comparison_buttons.js
 **/